import React from 'react';
import { Bookmark } from 'lucide-react';
import { useRobloky } from '../../context/RoblokyContext';
import { useAuth } from '../../context/AuthContext';
import { GameCard } from './GameCard';

export const SavedView: React.FC = () => {
  const { savedGames, savedLoading, openAuthModal } = useRobloky();
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="text-center py-16 space-y-3 max-w-md mx-auto">
        <p className="text-slate-200 font-bold">Sign in to keep your game library</p>
        <p className="text-xs font-mono text-slate-500">
          Saved games, likes and comments sync to your account.
        </p>
        <button
          onClick={() => openAuthModal('signin')}
          className="mt-2 px-5 py-2.5 rounded-xl bg-red-500 hover:bg-red-400 text-white text-xs font-bold transition-all"
        >
          Sign In
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-4 max-w-7xl mx-auto">
      <h1 className="flex items-center gap-2 text-lg sm:text-xl font-bold text-white">
        <Bookmark className="h-5 w-5 text-red-400" />
        Your Library
      </h1>
      {savedLoading ? (
        <p className="text-xs font-mono text-slate-500">Loading saved games...</p>
      ) : savedGames.length === 0 ? (
        <div className="text-center py-16 space-y-3">
          <p className="text-slate-300 font-bold">No saved games yet</p>
          <p className="text-xs font-mono text-slate-500">
            Tap the bookmark icon on any game to keep it here.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4">
          {savedGames.map((g) => (
            <GameCard key={g.placeId} game={g} />
          ))}
        </div>
      )}
    </div>
  );
};
